import { render, staticRenderFns } from "./CreateDistributionPage.vue?vue&type=template&id=0e663bb5&scoped=true&"
import script from "./CreateDistributionPage.vue?vue&type=script&lang=js&"
export * from "./CreateDistributionPage.vue?vue&type=script&lang=js&"
import style0 from "./CreateDistributionPage.vue?vue&type=style&index=0&id=0e663bb5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e663bb5",
  null
  
)

export default component.exports